import { render, staticRenderFns } from "./FinanceWalletsAggregation.vue?vue&type=template&id=8a35adba&scoped=true&"
import script from "./FinanceWalletsAggregation.vue?vue&type=script&lang=js&"
export * from "./FinanceWalletsAggregation.vue?vue&type=script&lang=js&"
import style0 from "./FinanceWalletsAggregation.vue?vue&type=style&index=0&id=8a35adba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a35adba",
  null
  
)

export default component.exports